<div class="filter-group" data-group-visibility-id="showDynamicFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showDynamicFilters" (click)="filter.groupVisibility.showDynamicFilters = !filter.groupVisibility.showDynamicFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Maps" [activeRules]="activeRules.mapFiltersPoe1">
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showDynamicFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showDynamicFilters">

      <div class="filter full-span" [class.disabled]="!filter.dynamicWaystones">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!filter.dynamicWaystones" (click)="toggleDynamicWaystones()"></button>
        </span>
        <span class="filter-body">
          <span filter-title text="Maps" ruleId="maps-dynamic">
            Special maps like Influenced, Memory-Influenced, Blight-Ravaged and Delirum Layer maps will always all be highlighted too.
          </span>
          <span class="sep"></span>
          <app-select style="width: 140px" [(ngModel)]="filter.waystoneFilterType" (selectedValueChange)="waystoneFilterTypeChanged()" [disabled]="!filter.dynamicWaystones">
            <app-option [value]="WaystoneFilterType.StaticDefault" [text]="'Static'"></app-option>
            <app-option [value]="WaystoneFilterType.Dynamic" [text]="'Level-Based'"></app-option>
            <app-option [value]="WaystoneFilterType.StaticStrict" [text]="'Endgame'"></app-option>
          </app-select>
          @if (filter.waystoneFilterType === WaystoneFilterType.Dynamic) {
            <span class="sep"></span>
            <div class="filter-title filter-label" [class.disabled]="filter.dynamicWaystones">
              Current Tier
            </div>
            <span class="sep"></span>
            <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax"
              [disabled]="!filter.dynamicWaystones" [(ngModel)]="filter.dynamicWaystonesLevel" (keyup)="daynamicWaystoneLevelChanged()">
          }
        </span>
      </div>

      @if (filter.waystoneFilterType === WaystoneFilterType.StaticStrict) {
        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="Nightmare"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier17Corrupted"
              filterPropertyName="mapTypesT17Corrupted"
              exampleName="Nightmare Map"
              [isWaystone]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-t17.png" class="negative-left-margin"> 8-Mod
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier17"
              filterPropertyName="mapTypesT17"
              exampleName="Nightmare Map"
              [isWaystone]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-t17.png" class="negative-left-margin"> Normal
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="{{ isMobile() ? 'T16.5' : 'T16 Memory-Influenced' }}"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16MemoryInfluencedCorrupted"
              filterPropertyName="mapTypesT16MemoryInfluencedCorrupted"
              exampleName="Map (Tier 16)"
              [isWaystone]="true"
              [memoryStrands]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-memory-influenced.png" class="negative-left-margin"> 8-Mod
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16MemoryInfluenced"
              filterPropertyName="mapTypesT16MemoryInfluenced"
              exampleName="Map (Tier 16)"
              [isWaystone]="true"
              [memoryStrands]="true">
              <img src="{{ imgPrefix }}/img/maps/map-memory-influenced.png" class="negative-left-margin"> Normal
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="Blight-Ravaged"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16BlightRavagedCorrupted"
              filterPropertyName="mapTypesBlightRavagedCorrupted"
              exampleName="Blight-Ravaged Map"
              [isWaystone]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-blight-ravaged.png" class="negative-left-margin"> 8-Mod
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16BlightRavaged"
              filterPropertyName="mapTypesBlightRavaged"
              exampleName="Blight-Ravaged Map"
              [isWaystone]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-blight-ravaged.png" class="negative-left-margin"> Normal
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="T16 Special"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16Influenced"
              filterPropertyName="mapTypesT16Influenced"
              exampleName="Influenced Map (Tier 16)"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-influenced.png" class="negative-margins">
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16Blighted"
              filterPropertyName="mapTypesT16Blighted"
              exampleName="Blighted Map (Tier 16)"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-blighted.png" class="negative-margins">
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16Delirium"
              filterPropertyName="mapTypesT16Delirium"
              exampleName="Delirium Map (Tier 16)"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-delirium.png" class="negative-margins">
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="T16"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16EightMod"
              filterPropertyName="mapTypesT16EightMod"
              exampleName="8-Mod Corrupted Map (Tier 16)"
              [isWaystone]="true"
              [rarity]="Rarity.Rare">
              <img src="{{ imgPrefix }}/img/maps/map-normal.png" class="negative-left-margin"> 8-Mod
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsTier16Normal"
              filterPropertyName="mapTypesT16Normal"
              exampleName="Map (Tier 16)"
              [isWaystone]="true">
              @if (isMobile()) {
                <img src="{{ imgPrefix }}/img/maps/map-normal.png" class="negative-margins">
              } @else {
                <img src="{{ imgPrefix }}/img/maps/map-normal.png" class="negative-left-margin"> Normal
              }
            </app-filter-checkbox-group>
          </span>
        </div>

        <div class="filter filter-property filter-padded-left" style="width: 100%;">
          <span class="filter-body">
            <span filter-title text="T" style="width: 30px;"></span>
            <span class="sep"></span>
            <!-- <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.width]="!isMobile() ? '64px' : '40px'" [style.min-width]="!isMobile() ? '64px' : '40px'"
              [disabled]="!filter.mapTypesLowTierInfluenced && !filter.mapTypesLowTierMemoryInfluenced && !filter.mapTypesLowTierBlighted && !filter.mapTypesLowTierDelirium"
              [(ngModel)]="filter.mapTypesLowTierMinTier" (keyup)="mapTypesLowTierMinTierChanged()"> -->
            <input type="number" placeholder="min" maxlength="2" pattern="[0-9.,]*" inputmode="numeric" step="any" class="form-control minmax" [style.width]="!isMobile() ? '64px' : '40px'" [style.min-width]="!isMobile() ? '64px' : '40px'"
              [disabled]="!filter.mapTypesLowTierMemoryInfluenced && !filter.mapTypesLowTierBlighted && !filter.mapTypesLowTierDelirium"
              [(ngModel)]="filter.mapTypesLowTierMinTier" (keyup)="mapTypesLowTierMinTierChanged()">
            <span class="sep"></span>
            <span class="spacer" style="display: table-cell; width: 100%; background-color: rgba(45, 49, 54, .3); padding: 0"></span>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsLowTierMemoryInfluenced"
              filterPropertyName="mapTypesLowTierMemoryInfluenced"
              [exampleName]="'Memory-Influenced Map (Tier ' + filter.mapTypesLowTierMinTier + ')'"
              [isWaystone]="true"
              [memoryStrands]="true">
              <img src="{{ imgPrefix }}/img/maps/map-memory-influenced.png" class="negative-left-margin">
            </app-filter-checkbox-group>
            <!-- <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsLowTierInfluenced"
              filterPropertyName="mapTypesLowTierInfluenced"
              [exampleName]="'Influenced Map (Tier ' + filter.mapTypesLowTierMinTier + ')'"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-influenced.png" class="negative-left-margin">
            </app-filter-checkbox-group> -->
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsLowTierBlighted"
              filterPropertyName="mapTypesLowTierBlighted"
              [exampleName]="'Blighted Map (Tier ' + filter.mapTypesLowTierMinTier + ')'"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-blighted.png" class="negative-left-margin">
            </app-filter-checkbox-group>
            <span class="sep"></span>
            <app-filter-checkbox-group
              [filter]="filter"
              [equipmentType]="EquipmentType.MapsLowTierDelirium"
              filterPropertyName="mapTypesLowTierDelirium"
              [exampleName]="'Delirium Map (Tier ' + filter.mapTypesLowTierMinTier + ')'"
              [isWaystone]="true">
              <img src="{{ imgPrefix }}/img/maps/map-delirium.png" class="negative-left-margin">
            </app-filter-checkbox-group>
          </span>
        </div>
      }

      @if (filter.dynamicWaystones && filter.waystoneFilterType === WaystoneFilterType.Dynamic) {
        <div class="filter full-span" [class.disabled]="!filter.dynamicWaystones">
          <span class="filter-body filter-body-no-checkbox">
            <div class="threshold-set">
              @if (dynamicWaystoneThresholds[0].level !== '🞪') {
                <app-tier-style class="threshold" [displayable]="fTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" [label]="dynamicWaystoneThresholds[0].level"
                  [exampleName]="'Map (Tier ' + dynamicWaystoneThresholds[0].level + ')'" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              } @else { <div class="threshold"></div> }

              @if (dynamicWaystoneThresholds[1].level !== '🞪') {
                <app-tier-style class="threshold" [displayable]="eTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" [label]="dynamicWaystoneThresholds[1].level"
                  [exampleName]="'Map (Tier ' + dynamicWaystoneThresholds[1].level + ')'" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              } @else { <div class="threshold"></div> }

              @if (dynamicWaystoneThresholds[2].level !== '🞪') {
                <app-tier-style class="threshold" [displayable]="dTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" [label]="dynamicWaystoneThresholds[2].level"
                  [exampleName]="'Map (Tier ' + dynamicWaystoneThresholds[2].level + ')'" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              } @else { <div class="threshold"></div> }

              @if (dynamicWaystoneThresholds[3].level !== '🞪') {
                <app-tier-style class="threshold" [displayable]="cTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" [label]="dynamicWaystoneThresholds[3].level"
                  [exampleName]="'Map (Tier ' + dynamicWaystoneThresholds[3].level + ')'" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              } @else { <div class="threshold"></div> }

              @if (dynamicWaystoneThresholds[4].level !== '🞪') {
                <app-tier-style class="threshold" [displayable]="bTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" [label]="dynamicWaystoneThresholds[4].level"
                  [exampleName]="'Map (Tier ' + dynamicWaystoneThresholds[4].level + ')'" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              } @else { <div class="threshold"></div> }
            </div>
          </span>
        </div>
      } @else if (filter.dynamicWaystones && filter.waystoneFilterType === WaystoneFilterType.StaticDefault) {
        <div class="filter full-span">
          <span class="filter-body filter-body-no-checkbox">
            <div class="threshold-set">
              <app-tier-style class="threshold" [displayable]="dTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" label="≥ 1"
                exampleName="Map (Tier 1)" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              <app-tier-style class="threshold" [displayable]="cTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" label="≥ 6"
                exampleName="Map (Tier 6)" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
              <app-tier-style class="threshold" [displayable]="bTierWaystone" [allowedDisplayTypes]="[DisplayType.EquipmentTier]" [editable]="false" label="≥ 11"
                exampleName="Map (Tier 11)" tooltipAlign="left" [isWaystone]="true"></app-tier-style>
            </div>
          </span>
        </div>
      }
    </div>
    <div class="clear"></div>
  }
</div>
